export default "__VITE_ASSET__53098f48__"